import React, { FC } from "react";
import {
  OccupancyMetricsChart,
  PeriodType,
} from "@/components/pages/dashboard/components/charts/dashboard_charts/OccupancyMetricsChart";
import { useDashboardAnalyticsChartData } from "@/components/pages/dashboard/hooks/useDashboardAnalyticsChartData";

interface Props {
  periodType: PeriodType;
  showGuestSatisfaction?: boolean;
  showUpsells?: boolean;
}

export const DashboardAnalytics: FC<Props> = ({
  periodType,
  showGuestSatisfaction = true,
  showUpsells = true,
}) => {
  const chart = useDashboardAnalyticsChartData(periodType);
  return (
    <div className="flex min-h-0 flex-1 flex-col overflow-visible">
      <OccupancyMetricsChart
        periodType={periodType}
        categories={chart.categories}
        occupancyData={chart.occupancyData}
        guestSatisfactionData={chart.guestSatisfactionData}
        upsellsData={chart.upsellsData}
        showGuestSatisfaction={showGuestSatisfaction}
        showUpsells={showUpsells}
      />
    </div>
  );
};
